import styled from "styled-components";

export const Wrapper = styled.div`
  display: grid;

  grid-template-columns: 1fr;
  grid-template-rows: auto;
  border-radius: 8px;
`;

export const FullscreenButton = styled.div``;
export const Icon = styled.div``;
export const Title = styled.div`
  place-self: center start;

  animation: ease 0.4s fadeInRight;
  font-size: 1.05rem;
  font-style: normal;
  font-weight: 700;
  line-height: 20px;
  letter-spacing: 0em;
  text-align: left;
  border-bottom: 2px solid currentColor;
  margin-bottom: 4px;
`;
export const Header = styled.div`
  padding: 10px 30px;
  display: grid;
  grid-gap: 10px;
  grid-template-columns: auto 1fr auto;
  place-items: center;
`;
export const Content = styled.div`
  padding: 20px 23px;
  overflow: hidden;
`;
